<uni-table-top-bar-item>
  <uni-link (click)="clearAllFilters()" icon="fa-trash-alt" type="secondary">
    {{ 'action.clearAllFilters' | translate }}
  </uni-link>
</uni-table-top-bar-item>
